<template>
  <on-click-outside :do="close">
    <div>
      <div class="input-group date">
        <input
          type="text"
          class="form-control"
          :value="value"
          @input="onInputDate"
          v-bind="{
            placeholder: format,
            ...$attrs
          }"
          ref="inputDatePicker"
          @focus="open"
          @keydown="validateKeyInput"
        />
        <div class="input-group-addon" @click="open">
          <i class="fa fa-calendar"></i>
        </div>
      </div>
      <div
        class="bootstrap-datetimepicker-widget dropdown-menu bottom date-picker-dropdown"
        ref="dropdown"
        v-show="isOpen"
      >
        <ul class="list-unstyled">
          <li class="collapse in">
            <year-picker
              @select-year="selectYear"
              :date-prop="value"
              :format="format"
            />
          </li>
        </ul>
      </div>
    </div>
  </on-click-outside>
</template>

<script>
import Popper from 'popper.js'
import OnClickOutside from '@/components/OnClickOutside.vue'
import YearPicker from '@/components/DatePicker/YearPicker'

export default {
  name: 'TsDatePickerInput',
  inheritAttrs: false,
  components: { YearPicker, OnClickOutside },
  props: {
    value: {
      type: String | Number
    },
    closeOnSelect: {
      type: Boolean
    },
    format: {
      type: String,
      default: 'YYYY'
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  beforeDestroy() {
    this.popper !== undefined && this.popper.destroy()
  },
  methods: {
    open() {
      if (
        this.$attrs.disabled !== undefined &&
        this.$attrs.disabled !== false
      ) {
        return
      }

      if (this.isOpen) {
        return
      }

      this.isOpen = true
      this.$nextTick(() => {
        this.setupPopper()
      })
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(
          this.$refs.inputDatePicker,
          this.$refs.dropdown,
          {
            placement: 'bottom',
            positionFixed: true,
            modifiers: {
              offset: {
                enabled: true,
                fn: data => {
                  data.offsets.popper.left = data.offsets.reference.left
                  data.offsets.popper.right = data.offsets.reference.right

                  return data
                },
                order: 840
              }
            }
          }
        )
      } else {
        this.popper.scheduleUpdate()
      }
    },
    close() {
      if (!this.isOpen) {
        return
      }
      this.isOpen = false
    },
    selectYear(year) {
      this.$emit('input', year)

      if (this.closeOnSelect) this.close()
    },
    validateKeyInput(e) {
      if (
        [
          'Backspace',
          'Delete',
          'ArrowLeft',
          'ArrowRight',
          'ArrowUp',
          'ArrowDown',
          'Home',
          'End',
          'Enter'
        ].includes(e.key) ||
        e.shiftKey ||
        e.ctrlKey ||
        e.altKey
      ) {
        return
      }

      if (this.value.length < 4 && /[0-9]/.test(e.key)) {
        return
      }

      e.preventDefault()
    },
    onInputDate(e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-picker-dropdown {
  top: 7px !important;
  z-index: 1000;
}
</style>
